import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import { ExperimentResourcesBase } from "./ExperimentResourcesBase.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ExperimentResources = class extends ExperimentResourcesBase {
  constructor() {
    super(EnvironmentService.endpoints.expmanVCurrent, "/experiments");
  }
};
ExperimentResources = __decorateClass([
  WPSProxyConverter()
], ExperimentResources);
const ExperimentResources$1 = new ExperimentResources();
export {
  ExperimentResources,
  ExperimentResources$1 as default
};
//# sourceMappingURL=ExperimentResources.js.map
